import { render, staticRenderFns } from "./krathongItem.vue?vue&type=template&id=d03ed5e8&scoped=true"
import script from "./krathongItem.vue?vue&type=script&lang=js"
export * from "./krathongItem.vue?vue&type=script&lang=js"
import style0 from "./krathongItem.vue?vue&type=style&index=0&id=d03ed5e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03ed5e8",
  null
  
)

export default component.exports